// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Pt-z","imageAndVideoCount":"Qt-z","imageAndVideoContainer":"Rt-z","viewAllReviews":"St-z"};